/**
 * MUI Select `MenuProps` for dark Status / Category filter dropdowns.
 * Matches product row actions menu (#262626 / #3F3F3F).
 */
export const PRODUCT_FILTER_MENU_PROPS = {
  PaperProps: {
    sx: {
      bgcolor: "#262626",
      borderRadius: "16px",
      mt: 0.5,
      boxShadow: "0 12px 32px rgba(0, 0, 0, 0.28)",
      py: 0.75,
      px: 0.75,
      maxHeight: 320,
      "& .MuiList-root": {
        py: 0,
      },
      "& .MuiMenuItem-root": {
        color: "#FFFFFF",
        fontSize: "13px",
        fontWeight: 500,
        borderRadius: "12px",
        py: 1.1,
        px: 1.5,
        minHeight: 0,
        "&:hover": {
          backgroundColor: "#3F3F3F",
        },
        "&.Mui-selected": {
          backgroundColor: "#3F3F3F",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#3F3F3F",
          },
        },
        "&.Mui-focusVisible": {
          backgroundColor: "#3F3F3F",
        },
      },
    },
  },
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
};
